module.exports = __webpack_public_path__ + "img/connection-hub.7cbadc1f.svg";